import { getCurrentPermissions } from './currentUser';

/**
 * LE VOCI DEL SITO, lette dal gettone.
 *
 * Il catalogo dei permessi ha due lati: BACKOFFICE (le pagine e i comandi
 * del backoffice) e FRONTEND, cioe' quello che questo sito mostra a chi
 * entra. Le voci FRONTEND le legge il sito, dal campo `permissions` del
 * gettone, e decidono cosa si vede; di regola nessun servizio le controlla
 * (l'eccezione, SITE_BETS_CANCEL, e' scritta qui sotto). La regola e'
 * una: chi ha la voce vede la cosa; chi non ce l'ha non vede la voce di menu
 * e, se arriva alla pagina scrivendo l'indirizzo, trova «non disponibile»
 * (components/Home/ConVoce.js). La radice della rete ha tutto il catalogo
 * nel gettone, quindi vede tutto.
 *
 * Le diciassette voci, e dove si leggono:
 *   Il mio conto
 *     SITE_PROFILE_VIEW          Il mio profilo
 *     SITE_MOVEMENTS_VIEW        Lista movimenti
 *     SITE_BETS_VIEW             Lista scommesse (MyBets, MyTickets)
 *     SITE_PASSWORD_MANAGE       Sicurezza: cambio password
 *     SITE_MESSAGES_VIEW         Messaggi
 *     SITE_BETS_CANCEL           il tasto «Annulla la giocata» nel ticket
 *                                aperto (BloccoAnnulla). Questa la controlla
 *                                ANCHE ticket-service, all'annullamento:
 *                                toglierla impedisce di annullare, non solo
 *                                di vedere il tasto. Il tempo e l'importo li
 *                                decide il backoffice (Impostazioni schedina
 *                                › Annullamento dal cliente).
 *   Gioco
 *     CREDIT_BET                 giocare col proprio conto. Lo controlla
 *                                credit-service alla giocata; il sito oggi
 *                                non mostra ne' nasconde niente per questa
 *                                voce, e non si inventa un blocco nuovo.
 *   Pagamenti
 *     SITE_DEPOSIT               Versamento: la Cassa, linguetta Versa
 *     SITE_WITHDRAW              Prelievo: la Cassa, linguetta Preleva
 *   Rete
 *     SITE_NETWORK_VIEW          Lista utenti
 *     SITE_NETWORK_DETAILS_VIEW  movimenti e giocate di una posizione della
 *                                rete, dalla sua scheda (?utente=)
 *     SITE_USER_CREATE           Nuova posizione
 *     SITE_TRANSFER              Giroconto
 *     SITE_REPORTS_VIEW          Report
 *   Quote e commissioni
 *     SITE_ODDS_VIEW             Quote
 *     SITE_COMMISSIONS_VIEW      Commissioni
 *     SITE_COMMISSIONS_MANAGE    Commissioni, gestione
 *
 * PRIMA il sito leggeva voci del backoffice, e una voce sola copriva due
 * cose diverse: negare a un livello la lista della rete gli toglieva anche
 * il resto, e profilo, password, cassa e messaggi non avevano nessuna voce
 * (si vedevano e basta). Adesso ogni cosa ha la sua. La migrazione di
 * rbac-service ha copiato ogni decisione sui nomi nuovi, e ha detto «si'»
 * sotto la radice alle voci che prima erano libere: chi vedeva una cosa
 * continua a vederla, e qui non serve nessun ripiego sul nome vecchio.
 *
 * Questo e' l'UNICO posto che risponde «ha la voce X?»: i menu (la striscia
 * in alto, la barra in basso, la skin Nova), le rotte e le pagine chiedono
 * tutti qui. Un nome che non sta nel catalogo e' un errore di battitura che
 * nasconderebbe una pagina per sempre: in sviluppo lo si dice.
 */
export const VOCI_DEL_SITO = Object.freeze([
  'SITE_PROFILE_VIEW', 'SITE_MOVEMENTS_VIEW', 'SITE_BETS_VIEW', 'SITE_PASSWORD_MANAGE', 'SITE_MESSAGES_VIEW',
  'SITE_BETS_CANCEL',
  'CREDIT_BET',
  'SITE_DEPOSIT', 'SITE_WITHDRAW',
  'SITE_NETWORK_VIEW', 'SITE_NETWORK_DETAILS_VIEW', 'SITE_USER_CREATE', 'SITE_TRANSFER', 'SITE_REPORTS_VIEW',
  'SITE_ODDS_VIEW', 'SITE_COMMISSIONS_VIEW', 'SITE_COMMISSIONS_MANAGE',
]);

function conosciuta(voce) {
  if (process.env.NODE_ENV !== 'production' && !VOCI_DEL_SITO.includes(voce)) {
    console.warn(`Voce del sito sconosciuta: ${voce} (vedi utils/permessi.js)`);
  }
  return voce;
}

/** Ha questa voce nel gettone. Senza gettone, o con uno scaduto, non ha niente. */
export function haLaVoce(voce) {
  return getCurrentPermissions().includes(conosciuta(voce));
}

/** Ha almeno una di queste voci (una sola, o un elenco). */
export function haUnaVoce(voci) {
  const elenco = Array.isArray(voci) ? voci : [voci];
  const permessi = getCurrentPermissions();
  return elenco.some((v) => permessi.includes(conosciuta(v)));
}
